<div [class.edit-mode]="edit">
    <p-fileUpload
        #fileUpload
        [customUpload]="true"
        [multiple]="multiple"
        [accept]="accept"
        [maxFileSize]="maxFileSize"
        [disabled]="disabled || disabledButtons || edit"
        [fileLimit]="fileLimit || 999"
        [invalidFileSizeMessageSummary]="invalidFileSizeMessageSummary"
        [invalidFileSizeMessageDetail]="invalidFileSizeMessageDetail"
        [invalidFileTypeMessageSummary]="invalidFileTypeMessageSummary"
        [invalidFileLimitMessageDetail]="invalidFileLimitMessageDetail"
        [invalidFileLimitMessageSummary]="invalidFileLimitMessageSummary"
        [invalidFileTypeMessageDetail]="invalidFileTypeMessageDetail"
        [style]="style"
        [styleClass]="styleClass"
        [previewWidth]="previewWidth"
        [chooseLabel]="chooseLabel"
        [uploadLabel]="uploadLabel"
        [cancelLabel]="cancelLabel"
        [chooseIcon]="chooseIcon"
        [uploadIcon]="uploadIcon"
        [cancelIcon]="cancelIcon"
        [mode]="mode"
        [showUploadButton]="showUploadButton"
        [showCancelButton]="showCancelButton"
        (uploadHandler)="onUpload($event.files)"
        (onSelect)="filesSelected($event)"
        (onRemove)="fileRemoved()"
        (onClear)="filesCleared()"
        appendTo="body">
        <ng-template pTemplate="toolbar">
            <div class="date-selector" *ngIf="showDateSelector">
                <m-parent-restricted-select-date
                    name="uploadDateTime"
                    [showValue]="true"
                    [allowTyping]="true"
                    [(ngModel)]="selectedDate"
                    [maxDate]="maxDate"
                    [minDate]="minDate"
                    [parentDate]="parentDate"
                    (onChange)="onDateChanged($event)">
                    <ng-template pTemplate="calendarHeader">
                        <div class="calendar-parent-header">
                            <span>{{ parentEntityName }} Created: {{ minDate | date: 'dd/MM/yyyy' }}</span>
                        </div>
                    </ng-template>
                </m-parent-restricted-select-date>
                <div class="p-error" *ngIf="!validDate">
                    <small [style.display]="'block'"> The selected date is invalid </small>
                </div>
            </div>
            <p-dropdown
                name="selectedDocumentType"
                *ngIf="!hasDocumentType && !edit"
                #documentType
                autoWidth="false"
                [options]="documentTypeOptions"
                [disabled]="disabled"
                placeholder="Document Type"
                [showClear]="true"
                [formControl]="selectedDocumentType"
                (onChange)="onDocumentTypeChanged()"
                (onBlur)="onTouched()"
                appendTo="body">
            </p-dropdown>
        </ng-template>

        <ng-template pTemplate="file" let-file let-i="index">
            <div class="p-fileupload-row">
                <div *ngIf="isImageExtension(file); else notImage">
                    <img [src]="file.objectURL" [width]="previewWidth"/>
                </div>

                <div *ngIf="!isImageExtension(file)">
                    <m-icon-svg iconName="mi-svg-document" [styleClass]="small"></m-icon-svg>
                </div>

                <div class="p-fileupload-filename">{{ file.name }}</div>
                <div>{{ fileUpload.formatSize(file.virtualSize ?? file.size) }}</div>
                <p-checkbox
                    [(ngModel)]="file.private"
                    (onChange)="onCheckboxChange($event)"
                    [hidden]="!showPrivateCheckboxes"
                    [binary]="true"
                    class="mr-2 border-noround-deep"
                    label="Private">
                </p-checkbox>
                <div class="w-10-proc">
                    <button type="button"
                            class="p-button-icon-only"
                            icon="pi pi-times"
                            pButton
                            [hidden]="edit"
                            (click)="fileUpload.remove(file, i)"
                            [disabled]="fileUpload.uploading">
                    </button>
                </div>
            </div>

            <div *ngIf="enableDuplicateCheck && hasFileWarning(file)" class="p-fileupload-file-warning">
                <div class="p-message p-message-warn p-component" role="alert">
                    <div class="p-message-wrapper">
                        <span class="p-message-icon pi pi-exclamation-triangle"></span>
                        <div class="p-message-text">
                            Looks like this file may already be added. Please check to avoid uploading a duplicate.
                        </div>
                        <button type="button"
                                class="p-message-close p-link"
                                (click)="clearFileWarning(file)"
                                aria-label="Close">
                            <i class="p-message-close-icon pi pi-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-fileUpload>
</div>
